export default {
  cardTitle: '设置台卡样式',
  cardDocTitle: '席位卡片',
  infoTitle: '打印座位信息',
  infoLoadFailed: '座位信息加载失败，请重试',
  printTableTab: '打印座位表',
  printMapTab: '打印座位图',
  withNames: '带姓名',
  withoutNames: '不带姓名',
  mapHint: '整场 A4 画框，包含场地、舞台和全部座位；不带姓名时显示座位号。',
  downloadPng: '下载 PNG',
  mapUnavailable: '当前场地暂无可打印的座位图',
  mapDownloaded: '座位图已生成',
  mapDownloadFailed: '座位图生成失败，请重试',
  printTable: '打印座位表',
  printMap: '打印座位图',
  styleTab: '1. 台卡样式',
  printTab: '2. 预览与打印',
  styleTitle: '座位单元台卡设置',
  styleMode: '台卡样式设置',
  styleModeUniform: '统一样式',
  styleModeSeparate: '分别样式',
  styleModeHint: '选择座位单元分别设置台卡样式。切换为统一样式时，将以当前单元样式覆盖全部座位单元。',
  styleModeUniformHint: '统一样式将应用到全部座位单元，并使用当前单元样式覆盖已有样式。',
  styleUnit: '选择座位单元',
  styleUnitPlaceholder: '请选择座位单元',
  styleNoUnits: '当前布局还没有可设置台卡的座位单元。',
  styleDone: '完成设置',
  styleNext: '下一步，预览与打印',
  goStyle: '去设置台卡样式',
  cardSaveFailed: '台卡样式保存失败，请重试。',
  cardUnitsEmpty: '当前布局还没有开启席位卡片的座位单元。',
  cardUnitsEmptyHint: '请先在「1. 台卡样式」中为需要打印的座位单元开启席位卡片，再回来打印席卡。',
  cardUnits: '已开启席位卡片的座位单元',
  content: '打印内容',
  backgroundOnly: '纯席卡背景',
  backgroundPerson: '背景 + 所选信息',
  cardCount: '将打印 {count} 张',
  cardPreviewSummary: '将打印 {count} 张{kind} · 打印样式预览',
  cardKindBackground: '纯席卡',
  cardKindPerson: '带所选信息的席卡',
  unassignedHint: '所选单元还没有分配人员，可选择“纯席卡背景”预览和打印背景。',
  blankCardHint: '未设置背景图片，打印为空白席卡。',
  previewReady: '已生成席卡预览，可选择「浏览器预览打印」查看完整效果，或点击「打印」直接进入浏览器打印。',
  sheets: '张',
  printerTitle: '选择打印机',
  printerLocationUnknown: '位置未提供',
  online: '在线',
  offline: '离线',
  noPrinters: '未检测到可用打印机，仍可使用浏览器打印或另存为 PDF。',
  browserPreview: '浏览器预览打印',
  print: '打印',
  printFailed: '打印失败，请重试。',
  printSettingsHint: '打印时请在浏览器打印面板关闭“页眉和页脚”，并选择与席卡匹配的纸张尺寸。',
  infoTable: '待打印座位表',
  infoFullTitle: '座位信息表',
  infoCount: '共 {count} 个已分配座位',
  infoStats: '共 {total} 个座位 · 已分配 {assigned} 人 · 空位 {empty} 个 · 预留 {reserved} 个 · 待分配 {pending} 人',
  activityLabel: '活动',
  sessionLabel: '会议场次',
  venueLabel: '场地',
  unboundActivity: '未绑定活动',
  noSession: '未选择场次',
  currentVenue: '当前场地',
  index: '序号',
  unit: '座位单元',
  seatPosition: '排 / 列',
  seatPositionValue: '第 {row} 排第 {column} 列',
  seatNo: '座位号',
  person: '姓名',
  jobTitle: '职务',
  organization: '单位',
  status: '状态',
  statusAssigned: '已分配',
  statusReserved: '预留座位',
  statusEmpty: '空位',
  viewFullTable: '查看完整表格',
  downloadTable: '下载表格（CSV）'
}
